module.exports = __webpack_public_path__ + "static/media/institute-21-min.3ce3a07a.webp";